import { render, staticRenderFns } from "./SemanticTable.vue?vue&type=template&id=273f5354&scoped=true"
import script from "./SemanticTable.vue?vue&type=script&lang=js"
export * from "./SemanticTable.vue?vue&type=script&lang=js"
import style0 from "./SemanticTable.vue?vue&type=style&index=0&id=273f5354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f5354",
  null
  
)

export default component.exports